import { getReportLinkSlug } from "./get-report-link-slug.js";

/**
 * Rota interna para visualizar um report-link em iframe.
 * @param {string} name - Nome do relatório
 * @returns {string}
 */
export function getReportLinkViewerPath(name) {
  const slug = getReportLinkSlug(name);
  return `/relatorios/${slug}`;
}
